<template>
  <div>
    <div class="page-content transaction-history" >
      <div class="page-title">
        <span>{{ $lang.messages.payments.toUpperCase() }} / </span>
        <span class="text">{{ $lang.messages.transactionHistory.toUpperCase() }}</span>
      </div>
      <div class="page-header">

        <div class="filter-select-btn" :class="{ 'disabled': listLoaded && list.length === 0 && !listFiltered }">
          <div  @click="toggleShowFilters">
            <span v-if="!showFilters">{{ $lang.messages.showFilters }}</span>
            <span v-if="showFilters">{{ $lang.messages.hideFilters }}</span>
            <img class="select-icon" src='@/assets/images/arrow_down.png' :class="{'select-icon-rotate': showFilters}" />
          </div>
        </div>
      </div>
      <div class="table-wrapper">
        <div class="table-all-filters" :class="{'show-filters': showFilters}" v-if="(listLoaded && list.length > 0) || listFiltered">
          <div class="table-filters clearfixing">
            <section>
              <div>
                <!-- Recipient -->
                <div class="part long-part">
                  <p class="label">{{ $lang.messages.recipient }}</p>
                  <div class="wrapper">
                    <autocomplete
                      ref="payor"
                      :name="'payor'"
                      :items="coparentsList"
                      :placeholder="$lang.messages.selectRecipient"
                      :validateProp="false"
                      @optionChanged="onSelectedRecipient" />
                  </div>
                </div>
                <!-- Payor -->
                <div class="part long-part">
                  <p class="label">{{ $lang.messages.payor }}</p>
                  <div class="wrapper">
                    <autocomplete
                      ref="recipient"
                      :name="'recipient'"
                      :items="coparentsList"
                      :placeholder="$lang.messages.selectPayor"
                      :validateProp="false"
                      @optionChanged="onSelectedPayor" />
                  </div>
                </div>
              </div>
              <div>
                <!-- Date -->
                <div class="part datepicker-part">
                  <p class="label">{{ $lang.messages.dueDateFrom }}</p>
                  <f-p-datepicker
                    :initialBlank="true"
                    ref="dateFrom"
                    @optionChanged="onSelectedDateFrom"
                    @click="onClickDateFrom">
                  </f-p-datepicker>
                  <div class="error">
                    <img
                      v-show="(errors.has('dateFrom') && !blurredDatepickerProp)"
                      src="@/assets/images/validation_ico.png"
                      alt="Red exclamation mark"
                      class="error-icon" />
                    <div class="error-tooltip" v-show="errors.has('dateFrom') && !blurredDatepickerProp ">
                      <div class="text">
                        {{ errors.first('dateFrom') }}
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="input-devider">
                <div class="part datepicker-part">
                  <p class="label">{{ $lang.messages.dueDateTo }}</p>
                  <f-p-datepicker
                    :initialBlank="true"
                    ref="dateTo"
                    @optionChanged="onSelectedDateTo">
                  </f-p-datepicker>
                </div>
              </div>
            </section>
            <section>
              <div>
                <!-- Child -->
                <div class="part long-part">
                  <p class="label">{{ $lang.messages.child }}</p>
                  <div class="wrapper">
                    <cases-checklist
                      v-if="casesList.length"
                      :items="casesList"
                      :placeholder="$lang.messages.selectChildren"
                      :name="'casesList'"
                      :key="rerender"
                      :filterNoDisable="true"
                      :validateProp="false"
                      ref="children"
                      @optionChanged="onSelectedChildren"
                    >
                    </cases-checklist>
                  </div>
                </div>
                <!-- Payment Type -->
                <div class="part long-part">
                  <p class="label">{{ $lang.messages.expenseType }}</p>
                  <div class="wrapper">
                    <autocomplete
                      ref="expenseTypes"
                      :name="'expenseType'"
                      :items="expenseTypes"
                      :placeholder="$lang.messages.expenseType"
                      :validateProp="false"
                      @optionChanged="onSelectedExpenseType"
                    />
                  </div>
                </div>
              </div>
              <div>
                <!-- Amount -->
                <div class="part short-left-part">
                  <p class="label">{{ $lang.messages.amount }}</p>
                  <div class="input-wrapper input-field" :class="{'error-input' : (errors.has('amountFrom') && formSubmitted)}">
                    <input
                      type="number"
                      :placeholder="$lang.messages.from"
                      class="input input-currency"
                      v-model="amountFrom"
                      name="amountFrom"
                      ref="amountFrom"
                      v-validate="'min_value:1|decimal:2'" />
                    <span class="input-currency-sign">
                  <currency-sign :currency="currencyString"></currency-sign>
                </span>
                    <img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon">
                    <div class="error-tooltip" v-show="(errors.has('amountFrom') && formSubmitted)">
                      <div class="text">
                        {{ errors.first('amountFrom') }}
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="input-devider">
                <div class="part short-right-part">
                  <br />
                  <div class="input-wrapper input-field no-title" :class="{'error-input' : (errors.has('amountTo') && formSubmitted)}">
                    <input
                      type="number"
                      :placeholder="$lang.messages.to"
                      class="input input-currency"
                      name="amountTo"
                      v-model="amountTo"
                      v-validate="'min_value:1|decimal:2|isBigger:amountFrom'" />
                    <span class="input-currency-sign">
                  <currency-sign :currency="currencyString"></currency-sign>
                </span>
                    <img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon">
                    <div class="error-tooltip" v-show="(errors.has('amountTo') && formSubmitted)">
                      <div class="text">
                        {{ errors.first('amountTo') }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Aditional filters-->
                <div class="part long-part">
                  <p class="label">{{ $lang.messages.additionalFilters }}</p>
                  <div class="wrapper">
                    <div class="input-wrapper input-field" @click="toggleAdditionFilters">
                      <input type="text" :placeholder="$lang.messages.selectFilters" class="input additional-filters-input" v-model="additionalFilters" />
                      <span>
                    <img class="icon additional-filters-ico" src='@/assets/images/arrow_down.png' />
                  </span>
                    </div>
                    <div class="filter-dropdown-selector" :class="{'select-menu-collapsed': additionFilters}">
                      <label class="checkbox-wrapper">
                        {{ $lang.messages.discussed }}
                        <input type="checkbox" v-model="onlyUnderDiscussed">
                        <span class="checkmark"></span>
                      </label>
                      <label class="checkbox-wrapper">
                        {{ $lang.messages.scheduled }}
                        <input type="checkbox" v-model="onlyScheduled">
                        <span class="checkmark"></span>
                      </label>
                      <label class="checkbox-wrapper">
                        {{ $lang.messages.notes }}
                        <input type="checkbox" v-model="withNotes">
                        <span class="checkmark"></span>
                      </label>
                      <label class="checkbox-wrapper">
                        {{ $lang.messages.attachments }}
                        <input type="checkbox" v-model="withAttachments">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div class="table-filters selected-filters">
              <button class="clear-btn" @click="clearAllFilters">
                <span>X</span>
                {{ $lang.messages.clearAllFilters }}
              </button>
              <!--<button class="action-btn" @click="applyFilters">-->
              <!--  <span>{{ $lang.messages.applyFilters }}</span>-->
              <!--</button>-->
            </div>
          </div>
          <hr class="content-devider">
        </div>

        <f-p-table-transaction-history
          v-if="loading || (listLoaded && list.length > 0) || listFiltered"
          :list="list"
          :paginationParams="paginationParams"
          :mockData="listFiltered && list.length === 0"
          @sort="sort"
          @on-pagination-changed-table="onPaginationChanged"
          @loadExpenses="loadPayments"
          :loading="loading"
          :key="rerender">
        </f-p-table-transaction-history>

        <div v-if="(listLoaded && !listFiltered && list.length === 0)" class="table-placeholder">
          <hr class="content-devider">
          <img class="illustration" src='@/assets/images/empty_table.png' />
          <p class="text bold-text">{{ $lang.messages.nothingHere }}</p>
          <p class="text">{{ $lang.messages.setUpFirst }}</p>
          <p class="text">{{ $lang.messages.dontWorrySimpleSteps }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FPTableTransactionHistory from "@/components/common/tables/FPTableTransactionHistory"
  import { mapActions, mapGetters } from "vuex"
  import { GET_COPARENTS_CHILDREN, TRANSACTION_HISTORY_LIST, GET_PAYMENTS_TYPES } from "@/store/action.types"
  import Autocomplete from "@/components/common/Autocomplete"
  import ChildrenChecklist from '@/components/common/ChildrenChecklist'
  import CasesChecklist from "@/components/common/CasesChecklist";
  import FPDatepicker from '@/components/common/FPDatepicker';
  import CurrencySign from "@/components/common/CurrencySign"
  import { dateFormat, requestDateFormat } from '@/mixins/dateFormat';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "History",
    components: {
      FPTableTransactionHistory,
      Autocomplete,
      FPDatepicker,
      ChildrenChecklist,
      CurrencySign,
      'cases-checklist': CasesChecklist
    },
    mixins: [
      dateFormat,
      requestDateFormat
    ],
    data() {
      return {
        showFilters: false,
        additionFilters: false,
        listLoaded: false,
        listFiltered: false,
        list: [],
        childrenItems: [],
        payor: '',
        recipient: '',
        children: [],
        expenseTypes: [],
        expenseType: '',
        dateFrom: '',
        dateTo: '',
        amountFrom: '',
        amountTo: '',
        onlyUnderDiscussed: false,
        onlyScheduled: false,
        withNotes: false,
        withAttachments: false,
        additionalFilters: '',
        formSubmitted: false,
        serverErrors: false,
        childrenListGuid: [],
        copMatchGuid: '',
        payorGuid: '',
        payorName: '',
        recipientGuid: '',
        recipientName: '',
        sortParams: {
          orderProperty: "paymentDate",
          orderDirection: "DESC"
        },
        paginationParams: {
          pageNumber: 0,
          pageSize: 10,
          totalElements: 0,
          totalPages: 0
        },
        rerender: 0,
        blurredDatepickerProp: false,
        loading: true,
      };
    },
    computed: {
      ...mapGetters({
        coparentsList: 'coparents',
        casesList: 'cases',
        currencyString: 'currency',
        coparentGuid: 'coparentGuid',
      }),
      coparentName: function () {
          let name = '';
          for (let i of this.coparentsList) {
              if (i.guid === this.coparentGuid) {
                  name = i.name;
              }
          }

          return name;
      }
    },
    watch: {
      onlyUnderDiscussed: function(newVal) {
        if (newVal === true) {
          if (!this.additionalFilters.includes('discussed')) {
            this.additionalFilters = this.additionalFilters + ',' + 'discussed'
          }
        } else {
          if (this.additionalFilters.includes('discussed')) {
            this.additionalFilters = this.additionalFilters.replace('discussed', '')
          }
        }
        this.fixAdditionalFilters()
      },
      onlyScheduled: function(newVal) {
        if (newVal === true) {
          if (!this.additionalFilters.includes('scheduled')) {
            this.additionalFilters = this.additionalFilters + ',' + 'scheduled'
          }
        } else {
          if (this.additionalFilters.includes('scheduled')) {
            this.additionalFilters = this.additionalFilters.replace('scheduled', '')
          }
        }
        this.fixAdditionalFilters()
      },
      withNotes: function(newVal) {
        if (newVal === true) {
          if (!this.additionalFilters.includes('notes')) {
            this.additionalFilters = this.additionalFilters + ',' + 'notes'
          }
        } else {
          if (this.additionalFilters.includes('notes')) {
            this.additionalFilters = this.additionalFilters.replace('notes', '')
          }
        }
        this.fixAdditionalFilters()
      },
      withAttachments: function(newVal) {
        if (newVal === true) {
          if (!this.additionalFilters.includes('attachments')) {
            this.additionalFilters = this.additionalFilters + ',' + 'attachments'
          }
        } else {
          if (this.additionalFilters.includes('attachments')) {
            this.additionalFilters = this.additionalFilters.replace('attachments', '')
          }
        }
        this.fixAdditionalFilters()
      },
      dateFrom: function () {
        this.applyFilters();
      },
      dateTo: function () {
        this.applyFilters();
      },
      amountFrom: function() {
        this.applyFilters();
      },
      amountTo: function () {
        this.applyFilters();
      }
    },
    created() {
      this.$validator.extend('isBigger', (value, [otherValue]) => {
        return parseInt(value) >= parseInt(otherValue)
      },
      {
        hasTarget: true
      });
    },
    mounted() {
      this.onClickOutside()
      this.loadPayments()
      this.loadPaymentsTypes()
    },
    updated() {
      /*
      * When there are payor/recipient names present, which means the user wants to filter through the whole children filter
      * re-render the function for children filter
      */
      if (this.payorName || this.recipientName) {
        this.casesListFilter();
      }
    },
    methods: {
      ...mapActions({
        getCoparentsAction: GET_COPARENTS_CHILDREN,
        transactionHistoryListAction: TRANSACTION_HISTORY_LIST,
        getPaymentsTypesAction: GET_PAYMENTS_TYPES,
      }),
      onClickOutside() {
        let _this = this;
        document.addEventListener('click', function(e) {
          let dropdown = document.querySelector('.select-menu-type-1')
          let checkmark = document.querySelector('.checkmark')
          let checkbox = document.querySelector('.checkbox')
          let additionFiltersInput = document.querySelector('.additional-filters-input')
          let additionFiltersIco = document.querySelector('.additional-filters-ico')
          let clickedElement = e.target

          if ((additionFiltersInput !== clickedElement && additionFiltersIco !== clickedElement) && clickedElement !== dropdown) {
            _this.additionFilters = false
          } else {
            _this.actions = !_this.actions
          }
        });
      },
      toggleShowFilters() {
        if (this.list.length > 0 || this.listFiltered) {
          this.showFilters = !this.showFilters
        }
      },
      toggleAdditionFilters() {
        this.additionFilters = !this.additionFilters
      },
      casesListFilter() {
        /*
        * When user selects 'Me' as a payor or recipient and the other field is empty
        * don't filter the children since we want the user to select/deselect all children
        */
        if (this.payorName === this.coparentName || this.recipientName === this.coparentName) {
          if (!this.recipientGuid || !this.payorGuid) {
            this.casesList.forEach(caseIt => {
              caseIt.disabled = false;
              if (caseIt.children.length) {
                caseIt.children.forEach(elemChild => elemChild.disabled = false);
              }
            });
            return
          }
        }
        /*
        * Enable/disable children filter list based on user input
        */
        this.casesList.forEach(caseIt => {
          if (caseIt.coparentGuid !== this.copMatchGuid) {
            caseIt.disabled = true;
            if (caseIt.children.length) {
              caseIt.children.forEach(elemChild => elemChild.disabled = true );
            }
          } else {
            caseIt.disabled = false;
            if (caseIt.children.length) {
              caseIt.children.forEach(elemChild => elemChild.disabled = false);
            }
          }
        });
      },
      /*
      * @description Based on user interaction grab the user guid and store it
      * @param {String} - 'payor' or 'recipient'
      * @returns {String} - this.copMatchGuid
      */
      matchChildCopGuids(param) {
        if (param === 'recipient') {
          if (this.recipientName !== this.coparentName && this.recipientName !== '') {
            this.copMatchGuid = this.recipientGuid
          } else if (this.recipientName === this.coparentName || this.recipientName === '') {
              if (this.payorName !== this.coparentName && this.payorName !== '') {
                this.copMatchGuid = this.payorGuid
              } else {
                this.copMatchGuid = ''
              }
          } else {
            this.copMatchGuid = ''
          }
        }

        if (param === 'payor') {
          if (this.payorName !== this.coparentName && this.payorName !== '') {
            this.copMatchGuid = this.payorGuid
          } else if (this.payorName === this.coparentName || this.payorName === '') {
            if (this.recipientName !== this.coparentName && this.recipientName !== '') {
              this.copMatchGuid = this.recipientGuid
            } else {
              this.copMatchGuid = ''
            }
          } else {
            this.copMatchGuid = ''
          }
        }

        this.casesListFilter();
      },
      onSelectedPayor(value) {
        this.payorGuid = value.guid;
        this.payorName = value.name;
        this.matchChildCopGuids('payor');

        let payorValid = false;
        this.coparentsList.forEach(element => {
          if (element.name === value.name) {
            payorValid = true
          }
        });

        if (payorValid === true) {
          this.payor = value
          if (this.payor.guid !== this.coparentGuid) {
            this.childrenItems = [];
            this.loadCoparents(this.payor.guid);
            this.rerender+=1;
          }
        } else {
          this.payor = {}
        }
        this.applyFilters();
      },
      onSelectedRecipient(value) {
        this.recipientGuid = value.guid;
        this.recipientName = value.name;
        this.matchChildCopGuids('recipient');

        let recipientValid = false;
        this.coparentsList.forEach(element => {
          if (element.name === value.name) {
            recipientValid = true
          }
        });

        if (recipientValid === true) {
          this.recipient = value;
          if (this.recipient.guid !== this.coparentGuid) {
            this.childrenItems = [];
            this.loadCoparents(this.recipient.guid);
            this.rerender+=1;
          }
        } else {
          this.recipient = {}
        }
        this.applyFilters();
      },
      onSelectedChildren(results) {
        results.forEach(elem => {
          elem.children.forEach((childElem) => {
            if (childElem.clicked) {
              if (!this.childrenListGuid.includes(childElem.childGuid)) {
                this.childrenListGuid.push(childElem.childGuid)
              }
            } else if (!childElem.clicked) {
              if (this.childrenListGuid.includes(childElem.childGuid)) {
                this.childrenListGuid.splice(this.childrenListGuid.indexOf(childElem.childGuid), 1)
              }
            }
          })
        });
        this.applyFilters();
      },
      onSelectedExpenseType(value) {
        this.expenseType = value;
        this.applyFilters();
      },
      onSelectedDateFrom(value) {
        this.dateFrom = value;
        this.validateDates();
        this.applyFilters();
      },
      onSelectedDateTo(value) {
        this.dateTo = value;
        this.validateDates();
        this.applyFilters();
      },
      onClickDateFrom(value) {
        this.blurredDatepickerProp = value;
      },
      validateDates() {
        if(this.dateFrom !== '' && this.dateTo !== '')
        if (!(new Date(this.dateFrom) < new Date(this.dateTo))) {
          this.$validator.errors.add({
            field: 'dateFrom',
            msg: this.$lang.messages.vee_dateFromBeforeDateTo
          });
          this.$refs.dateFrom.setError(true);
        } else {
          this.$validator.errors.remove('dateFrom');
          this.$refs.dateFrom.setError(false);
        }
      },
      fixAdditionalFilters() {
        if (this.additionalFilters.substring(0, 1) === ',') {
          this.additionalFilters = this.additionalFilters.substring(1, this.additionalFilters.length)
        }
        if (this.additionalFilters.includes(',,')) {
          this.additionalFilters = this.additionalFilters.replace(',,', ',')
        }
        if (this.additionalFilters.substring(this.additionalFilters.length - 1, this.additionalFilters.length) === ",") {
          this.additionalFilters = this.additionalFilters.substring(0, this.additionalFilters.length - 1)
        }
        this.applyFilters();
      },
      clearAllFilters() {
        this.dateFrom = ''
        this.dateTo = ''
        this.amountFrom = ''
        this.amountTo = ''
        this.onlyUnderDiscussed = false
        this.onlyScheduled = false
        this.withNotes = false
        this.withAttachments = false
        this.payor = ''
        this.recipient = ''
        this.paymentStatus = ''
        this.children = []
        this.childrenItems = []
        this.eventType = ''
        this.childrenListGuid = []
        this.copMatchGuid = ''
        this.recipientGuid = ''
        this.payorGuid = ''
        this.recipientName = ''
        this.payorName = ''
        this.$refs.payor.clear()
        this.$refs.recipient.clear()
        this.$refs.children.clear()
        this.$refs.expenseTypes.clear()
        this.rerender = this.rerender + 1
        this.$refs.dateFrom.clearSelections()
        this.$refs.dateTo.clearSelections()
        this.loadPayments()
      },
      loadCoparents(guid) {
        this.getCoparentsAction(guid)
        .then(response => {
          response.data.data.forEach(element => {
            element.clicked = false
            this.childrenItems.push(element)
          })
        })
      .catch(error => {
        if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
          this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
        }
      })
      this.rerender+=1
      },
      loadPayments() {
        this.paginationParams.pageNumber = 0
        this.rerender+=1
        this.loading = true;
        this.transactionHistoryListAction({
          orderProperty: this.sortParams.orderProperty,
          orderDirection: this.sortParams.orderDirection,
          page : this.paginationParams.pageNumber,
          size : this.paginationParams.pageSize
        })
        .then(response => {
          this.list = []
          this.paginationParams.pageNumber = response.data.data.pageable.pageNumber
          this.paginationParams.pageSize = response.data.data.pageable.pageSize
          this.paginationParams.totalElements = response.data.data.totalElements
          this.paginationParams.totalPages = response.data.data.totalPages
          response.data.data.content.forEach((item) => {
            let firstExtension = ''
            let secondExtension = ''
            if (item.attachments.length >= 2) {
              firstExtension = item.attachments[0].extension
              secondExtension = item.attachments[1].extension
            } else if (item.attachments.length === 1) {
              firstExtension = item.attachments[0].extension
            }
            item.firstExtension = firstExtension.toLowerCase()
            item.secondExtension = secondExtension.toLowerCase()

            let count = item.attachments.length
            if (count === 0 || count === 1) {
              item.documentCount = count - 1
            } else if (count >= 2) {
              item.documentCount = count - 2
            }

            this.list.push(item)
          });
          this.listLoaded = true;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        });
      },
      applyFilters(isScroll=false) {
        this.listFiltered = true;
        let dateFrom = '';
        let dateTo = '';
        if (this.dateFrom !== '') {
          dateFrom =  this.requestDateFormat(this.dateFrom)
        }
        if (this.dateTo !== '') {
          dateTo = this.requestDateFormat(this.dateTo)
        }
        this.$validator.validateAll().then(result => {
          this.formSubmitted = true;
          if (result) {
            this.transactionHistoryListAction({
              expenseType: this.expenseType.expenseType === undefined ? null : this.expenseType.expenseType,
              recipientGuid : this.recipient.guid,
              payorGuid : this.payor.guid,
              childrenGuid: this.childrenListGuid,
              paymentDateFrom : dateFrom,
              paymentDateTo : dateTo,
              amountFrom : this.amountFrom,
              amountTo : this.amountTo,
              onlyUnderDiscussion : this.onlyUnderDiscussed,
              onlyScheduled : this.onlyScheduled,
              withNotes : this.withNotes,
              withAttachments : this.withAttachments,
              orderProperty: this.sortParams.orderProperty,
              orderDirection: this.sortParams.orderDirection,
              page : this.paginationParams.pageNumber,
              size : this.paginationParams.pageSize
            })
            .then(response => {
              let filteredList = []
              response.data.data.content.forEach((item) => {
                let firstExtension = ''
                let secondExtension = ''
                if (item.attachments.length >= 2) {
                  firstExtension = item.attachments[0].extension
                  secondExtension = item.attachments[1].extension
                } else if (item.attachments.length === 1) {
                  firstExtension = item.attachments[0].extension
                }
                item.firstExtension = firstExtension.toLowerCase()
                item.secondExtension = secondExtension.toLowerCase()

                let count = item.attachments.length
                if (count === 0 || count === 1) {
                  item.documentCount = count - 1
                } else if (count >= 2) {
                  item.documentCount = count - 2
                }

                filteredList.push(item)
              });
              this.list = filteredList
              this.paginationParams.pageNumber = response.data.data.pageable.pageNumber
              this.paginationParams.pageSize = response.data.data.pageable.pageSize
              this.paginationParams.totalElements = response.data.data.totalElements
              this.paginationParams.totalPages = response.data.data.totalPages
              if (isScroll) {
                setTimeout(() => {
                  document.body.scrollTo(0, document.body.scrollHeight);
                }, 0);
              }
            })
            .catch(error => {
              if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
                this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
              }
            });
          }
        });
      },
      sort(sortParam, sortDir) {
        if (sortParam !== "") {
          this.sortParams.orderProperty = sortParam
          this.sortParams.orderDirection = sortDir
          this.applyFilters()
        }
      },
      onPaginationChanged(paginationParams) {
        this.paginationParams = paginationParams;
        this.applyFilters(true);
      },
      loadPaymentsTypes() {
        this.getPaymentsTypesAction()
        .then(response => {
          this.expenseTypes = response.data.data.map(item => ({ name: item.displayName, expenseType: item.expenseType }))
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        })
      }
    },
  };
</script>
